module.exports = __webpack_public_path__ + "img/icon_otp_modal.fc877284.svg";